export default class ChromeMobileReloadPlayer {
  constructor(options = {}) {
    this._tech = options.tech;
    this._data = options.data;
    this._adStarted = false;
    this._overlayIsActive = false;
    this._overlay;
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  parentElement() {
    return this.tech().el().parentElement();
  }

  grandParentElement() {
    return this.parentElement().parentElement();
  }

  init() {
    this.bindFirstPlay();
    this.bindAdStart();
    this.bindAdEnd();
  }

  bindFirstPlay() {
    this.tech().on('firstplay', () => {
      setTimeout(() => {
        if (!this._adStarted) {
          this.toggleOverlay();
        }
      }, 4000);
    });
  }

  bindAdStart() {
    this.tech().on('adstart', () => {
      this._adStarted = true;
    });
  }

  bindAdEnd() {
    this.tech().on('adend', () => {
      setTimeout(() => {
        this.toggleOverlay();
      }, 4000);
    });
  }

  appendOverlay() {
    this._overlayIsActive = true;
    if (this.data().embed() === 'true') {
      this.parentElement().appendChild(this.getVideoOverlay());
    } else {
      this.grandParentElement().appendChild(this.getVideoOverlay());
    }
  }

  getVideoOverlay() {
    const loadingCoverDom = document.createElement('div');
    loadingCoverDom.className = 'vjs-loading-cover';

    const loadingSpinner = document.querySelector('.vjs-loading-spinner');
    const loadingSpinnerClone = loadingSpinner.cloneNode(true);
    loadingSpinnerClone.classList.add('vjs-loading-spinner-clone');

    const loadingSpinnerText = document.createElement('span');
    loadingSpinnerText.classList.add('vjs-spinner-text');
    loadingSpinnerText.innerHTML = 'Loading resources, it may take a while...';

    loadingSpinnerClone.appendChild(loadingSpinnerText);
    loadingCoverDom.appendChild(loadingSpinnerClone);

    this._overlay = loadingCoverDom;

    return this._overlay;
  }

  hideOverlay() {
    const loadingCover = document.querySelector('.vjs-loading-cover');

    if (loadingCover) {
      loadingCover.parentElement.removeChild(loadingCover);
      this._overlayIsActive = false;
    }
  }

  toggleOverlay() {
    if (!this.tech()._plugin) {
      this.hideOverlay();
      return;
    }

    if (this.tech().readyState() <= 2) {
      if(!this._overlayIsActive){
        this.appendOverlay();
      }

      this.tech().trigger('vp-clean-restart');
    } else {
      this.hideOverlay();
    }
  }
}
